/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Link_ButtonInputs */

const en_portalsignin_link_button = /** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email me a sign-in link`)
};

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const ar_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const he_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const ur_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const es_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const fr_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const de_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const pt_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const hi_portalsignin_link_button = en_portalsignin_link_button;

/** @type {(inputs: Portalsignin_Link_ButtonInputs) => LocalizedString} */
const bn_portalsignin_link_button = en_portalsignin_link_button;

/**
* | output |
* | --- |
* | "Email me a sign-in link" |
*
* @param {Portalsignin_Link_ButtonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_button = /** @type {((inputs?: Portalsignin_Link_ButtonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_ButtonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_link_button(inputs)
	if (locale === "he") return he_portalsignin_link_button(inputs)
	if (locale === "ur") return ur_portalsignin_link_button(inputs)
	if (locale === "es") return es_portalsignin_link_button(inputs)
	if (locale === "fr") return fr_portalsignin_link_button(inputs)
	if (locale === "de") return de_portalsignin_link_button(inputs)
	if (locale === "pt") return pt_portalsignin_link_button(inputs)
	if (locale === "hi") return hi_portalsignin_link_button(inputs)
	if (locale === "bn") return bn_portalsignin_link_button(inputs)
	return /** @type {LocalizedString} */ ("Email me a sign-in link")
});